import comp from "./UnitSelectionWithFilters";
export default comp;
